import Router from 'vue-router';
import logger from '@utils/logger';
let injected = false;
let originalPush;
let originalReplace;
// refs: https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
export const injectRouterMethods = () => {
    if (injected)
        return;
    originalPush = Router.prototype.push;
    originalReplace = Router.prototype.replace;
    // 注入的错误处理逻辑
    const errorHandler = (err) => {
        // 在导航守卫调用next(newLocation)重定向到其他地方
        if (Router.isNavigationFailure(err, Router.NavigationFailureType.redirected)) {
            logger.log('[VueRouter.errorHandler]', err);
            return err;
        }
        // 因为已经在目标位置被阻止导航
        if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
            logger.log('[VueRouter.errorHandler]', err);
            return err;
        }
        // rethrow error
        return Promise.reject(err);
    };
    Router.prototype.push = function push(location, onComplete, onAbort) {
        if (onComplete || onAbort) {
            return originalPush.call(this, location, onComplete, onAbort);
        }
        return originalPush.call(this, location).catch(errorHandler);
    };
    Router.prototype.replace = function replace(location, onComplete, onAbort) {
        if (onComplete || onAbort) {
            return originalReplace.call(this, location, onComplete, onAbort);
        }
        return originalReplace.call(this, location).catch(errorHandler);
    };
    injected = true;
};
